import intl from '../i18n';
import transifyReporter from '../transifyReporter';

type VariablesType = Record<string, string|number> | null | undefined;

export const getTrans = (key: string, fallback = '', variables: VariablesType = undefined) => {
  if (!key) {
    return fallback;
  }
  // 判断keyMap是否为空，为空说明初始化设置失败(如果上报，则每个key都会报，数据量太大)，因此不为空时搜集上报才有意义
  const isKeyMapEmpty = transifyReporter.isKeyMapEmpty();

  // 不在同步script标签引入的translation中，说明缺失，需上报
  if (!isKeyMapEmpty && !transifyReporter.isInKeyMap(key)) {
    transifyReporter.collectLostKeys(key);
  }

  let value: string | undefined = intl.get(key);
  // 根据key未获取到value值，说明异步script标签引入的extra_translation还没ready
  if (!isKeyMapEmpty && typeof value === 'undefined') {
    transifyReporter.collectNotAvailableKeys(key);
  }

  if (variables && value && value.trim().length > 0) {
    value = value.replace(/{(.*?)}/g, (match: string, key: any) => {
      const trimedKey = (key || '').trim();
      return variables?.[trimedKey] === 0 ? '0' : variables?.[trimedKey] || key;
    });
  }

  return value || fallback;
};
